export const behaviorCategories = [
  {
    id: 'circadian',
    name: 'CIRCADIAN HEALTH',
    behaviors: [
      { id: 'morning-light', name: 'See direct sunlight upon waking up?', unit: 'minutes', timing: true },
      { id: 'evening-light', name: 'Watch the sunset?', timing: true },
      { id: 'blue-light', name: 'Used blue light blocking glasses?', timing: true },
      { id: 'dark-room', name: 'Sleep in complete darkness?', timing: true }
    ]
  },
  {
    id: 'sleep',
    name: 'SLEEP',
    behaviors: [
      { id: 'share-bed', name: 'Share your bed?', timing: false },
      { id: 'usual-bed', name: 'Slept in the same bed as usual?', timing: false },
      { id: 'sleep-mask', name: 'Used sleep mask?', timing: false },
      { id: 'earplugs', name: 'Used earplugs?', timing: false },
      { id: 'room-temp', name: 'Room temperature optimal?', timing: false }
    ]
  },
  {
    id: 'nutrition',
    name: 'NUTRITION',
    behaviors: [
      { id: 'late-meal', name: 'Eat any food close to bedtime?', timing: true },
      { id: 'caffeine', name: 'Have any caffeine?', unit: 'servings', timing: true },
      { id: 'alcohol', name: 'Have any alcoholic drinks?', unit: 'drinks', timing: true },
      { id: 'hydration', name: 'Met hydration goal?', unit: 'liters', timing: false },
      { id: 'protein', name: 'Hit protein target?', unit: 'grams', timing: false }
    ]
  },
  {
    id: 'recovery',
    name: 'RECOVERY',
    behaviors: [
      { id: 'felt-recovered', name: 'Felt recovered?', timing: false },
      { id: 'meditation', name: 'Practiced meditation?', unit: 'minutes', timing: true },
      { id: 'cold-exposure', name: 'Cold exposure?', unit: 'minutes', timing: true },
      { id: 'sauna', name: 'Sauna session?', unit: 'minutes', timing: true },
      { id: 'massage', name: 'Recovery massage?', unit: 'minutes', timing: true }
    ]
  },
  {
    id: 'supplements',
    name: 'SUPPLEMENTS',
    behaviors: [
      { id: 'melatonin', name: 'Take a melatonin supplement?', unit: 'mg', timing: true },
      { id: 'magnesium', name: 'Take magnesium?', unit: 'mg', timing: true },
      { id: 'vitamin-d', name: 'Take Vitamin D?', unit: 'IU', timing: true },
      { id: 'fish-oil', name: 'Take Fish Oil?', unit: 'mg', timing: true },
      { id: 'creatine', name: 'Take Creatine?', unit: 'g', timing: true }
    ]
  },
  {
    id: 'lifestyle',
    name: 'LIFESTYLE',
    behaviors: [
      { id: 'travel', name: 'Travel on a plane?', timing: false },
      { id: 'work-stress', name: 'High work stress?', timing: false },
      { id: 'social', name: 'Social interaction?', unit: 'hours', timing: false },
      { id: 'screen-time', name: 'Screen time before bed?', unit: 'hours', timing: true },
      { id: 'nature-time', name: 'Time in nature?', unit: 'minutes', timing: true }
    ]
  }
];